import {
	axiosErrorHandler,
	get,
	patch,
	post,
} from 'models/shared/helpers/axiosInstance';
import { buildPathWithQueryParams } from 'models/shared/helpers/utils';
import {
	CreateGeofenceDto,
	Geofence,
	GeofenceFilterDto,
	PaginatedResponse,
	UpdateGeofenceDto,
} from '../interfaces/geofence.interface';

const baseGeofencePath = '/v1/geofences';

export const fetchGeofences = async (dto?: GeofenceFilterDto) => {
	try {
		const url = dto
			? buildPathWithQueryParams(baseGeofencePath, dto)
			: baseGeofencePath;
		const res = await get<PaginatedResponse<Geofence> | Geofence[]>(url);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const fetchGeofence = async (id: string) => {
	try {
		const url = `${baseGeofencePath}/${id}`;
		const res = await get<Geofence>(url);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const createGeofence = async (dto: CreateGeofenceDto) => {
	try {
		const res = await post<Geofence>(baseGeofencePath, dto);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const updateGeofence = async (id: string, dto: UpdateGeofenceDto) => {
	try {
		const url = `${baseGeofencePath}/${id}`;
		const res = await patch<Geofence>(url, dto);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};
